// Module-level state of the console (write gate, unsaved-edit flags, per-pick
// writers with their pending command ids) outlives any component. It belongs to the
// operator who built it, so it has to be dropped when the account goes away.
const resetters = new Set<() => void>();

export function registerPicksReset(reset: () => void): void {
  resetters.add(reset);
}

export function resetPicksState(): void {
  for (const reset of [...resetters]) reset();
}

interface AuthSessionLike {
  user?: { id?: string } | null;
}

// Sign-out is handled by the route change to the login page, not by the auth event:
// a refresh that fails while the operator still holds unsaved edits also signs out,
// and wiping the cache then would tear the editor (and the edits) away before the
// operator has been warned. A different user id is the one event that is safe to act
// on immediately.
export function createUserChangeWatcher(
  onUserChange: () => void,
): (event: string, session: AuthSessionLike | null) => void {
  let lastUserId: string | null = null;
  return (event, session) => {
    if (event === "SIGNED_OUT") {
      lastUserId = null;
      return;
    }
    const userId = session?.user?.id ?? null;
    if (userId === null) return;
    if (lastUserId !== null && lastUserId !== userId) onUserChange();
    lastUserId = userId;
  };
}
